(function () {
  const WHEEL_LINE_HEIGHT = 16;

  function getWheelDelta(event, nav) {
    if (event.deltaMode === 1) return event.deltaY * WHEEL_LINE_HEIGHT;
    if (event.deltaMode === 2) return event.deltaY * nav.clientWidth;
    return event.deltaY;
  }

  function handleCollectionSubnavWheel(event, nav) {
    if (!event || !nav || event.deltaY === 0) return false;

    const maxScrollLeft = nav.scrollWidth - nav.clientWidth;
    if (maxScrollLeft <= 0) return false;

    const delta = getWheelDelta(event, nav);
    const nextScrollLeft = Math.max(
      0,
      Math.min(maxScrollLeft, nav.scrollLeft + delta)
    );

    if (nextScrollLeft === nav.scrollLeft) return false;

    nav.scrollLeft = nextScrollLeft;
    event.preventDefault();
    return true;
  }

  function setupCollectionSubnav(nav) {
    if (nav.dataset.collectionSubnavWheelBound === 'true') return;

    nav.dataset.collectionSubnavWheelBound = 'true';
    nav.addEventListener(
      'wheel',
      (event) => handleCollectionSubnavWheel(event, nav),
      { passive: false }
    );

    const active = nav.querySelector('.collection-subnav__link.active');
    if (!active) return;

    active.scrollIntoView({
      behavior: 'instant',
      block: 'nearest',
      inline: 'center'
    });
  }

  const api = { handleCollectionSubnavWheel, setupCollectionSubnav };

  if (typeof window !== 'undefined') {
    window.CollectionSubnav = api;
  }

  if (
    typeof document !== 'undefined' &&
    typeof document.addEventListener === 'function'
  ) {
    const initialize = () =>
      document.querySelectorAll('.collection-subnav').forEach(setupCollectionSubnav);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  }
})();
